module.exports = __webpack_public_path__ + "static/media/cover.7f8f16ea.jpg";